// extracted by mini-css-extract-plugin
export default {"loader":"LoadingScreen_loader__vXLj0","spin":"LoadingScreen_spin__4mI4h"};